import useListAttractions from "@/hooks/api/attractions/useListAttractions"
import { Box, Divider, Typography } from "@mui/material"
import AdminAttractionCard from "./AdminAttractionCard"
import { Attraction } from "@/common/types"

const ViewAttractions = () => {
  const { data: attractions, isLoading } = useListAttractions({
    filters: { filterValue: [] },
  })

  if (isLoading) {
    return (
      <>
        <Typography>Loading</Typography>
      </>
    )
  }
  return (
    <>
      <Box p={2}>
        <Typography variant="h3">All Attractions</Typography>
        <Divider sx={{ p: 1 }} />
        {attractions.data.map((attraction: Attraction) => {
          return (
            <AdminAttractionCard
              key={attraction.attraction_id}
              attraction={attraction}
            />
          )
        })}
      </Box>
    </>
  )
}

export default ViewAttractions
